import styled from 'styled-components';

const Input = styled.input.attrs({
	type: 'password',
	autoComplete: 'off',
})`
	width: 100%;
	height: 100%;
	padding: 20px;
	border-width: 0;
	border-radius: 10px;
	font-family: 'GT Walsheim Pro';
	font-size: 16px;
	line-height: 18px;
	text-align: center;
	color: #fff;
	background-color: rgba(255, 255, 255, 0.05);
	transition:
		color 0.25s ease,
		background-color 0.25s ease;

	&::placeholder {
		text-align: center;
		color: #ffffff80;
		transition: color 0.25s ease;
	}
`;

const Container = styled.div`
	position: relative;
	width: 100%;
	height: 50px;
	display: flex;
	user-select: none;

	&:hover,
	&:focus-within {
		${Input} {
			color: #000;
			background-color: #fff;
			outline: none;

			&::placeholder {
				color: #00000080;
			}
		}
	}
`;

export { Input, Container };
